import { IVehicleBlacklistAPIState } from "../types/vehicleBlacklist.types";

export const VEHICLE_BLACKLIST_INITIAL_STATE: IVehicleBlacklistAPIState = {
  data: {
    list: [],
    totalPages: 0,
    totalRecords: 0,
  },
  pageProps: {
    isDescending: false,
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    sortingOn: "",
  },
  list: [],
  vehicles: [],
  loading: false,
  error: null,
  currentScreen: "list",
  selectedVehicleBlacklist: null,
};
